import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../images/adv_left_point.png';
var _hoisted_1 = {
  class: "adv_box"
};
var _hoisted_2 = {
  class: "adv_content container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_title"
}, " Our Advantages ", -1);

var _hoisted_4 = {
  class: "adv_content_box col-lg-12 col-md-12 col-sm-12 col-xs-12"
};
var _hoisted_5 = {
  class: "adv_content_item"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_left_point_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "adv_left_point"
})], -1);

var _hoisted_7 = {
  class: "adv_right_big_box"
};
var _hoisted_8 = {
  class: "adv_right_box"
};
var _hoisted_9 = {
  class: "adv_right_title"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_right_line"
}, null, -1);

var _hoisted_11 = {
  class: "adv_content_text"
};
var _hoisted_12 = {
  class: "heiden_box_adv"
};
var _hoisted_13 = ["onClick"];

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "upicon"
}, null, -1);

var _hoisted_15 = [_hoisted_14];

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "closeicon_line"
}, null, -1);

var _hoisted_17 = [_hoisted_16];

var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_right_bottom_line"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.porateAdvantageList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "adv_content_flex_box",
          key: index
        }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _hoisted_10, _createVNode(_component_el_collapse_item, {
          class: "article_collapse",
          name: index
        }, {
          title: _withCtx(function () {
            return [];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_11, _toDisplayString(item.content), 1)];
          }),
          _: 2
        }, 1032, ["name"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
          class: _normalizeClass(['adv_content_title', $setup.showMoreBtnState !== index ? 'adv_title_text_show' : 'adv_title_none'])
        }, _toDisplayString(item.content), 3)])]), _withDirectives(_createElementVNode("div", {
          class: "upicon_box",
          onClick: function onClick($event) {
            return $setup.toggleMore(index);
          }
        }, _hoisted_15, 8, _hoisted_13), [[_vShow, $setup.showMoreBtnState !== index]]), _withDirectives(_createElementVNode("div", {
          class: "upicon_box",
          onClick: _cache[0] || (_cache[0] = function () {
            return $setup.retract && $setup.retract.apply($setup, arguments);
          })
        }, _hoisted_17, 512), [[_vShow, $setup.showMoreBtnState == index]]), _hoisted_18])])]);
      }), 128))])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}